export const ProductRequirme = {
    Gateway: 'Gateway',
    MyMotoApp: 'MyMoto App',
    VirtualTerminal: 'Virtual Terminal',
    MyEcomm: 'MyEcomm',
    PDQ: 'PDQ'
};
